module.exports = new __parcel__URL__("C5O6.fe0bd831.jpeg").toString();